import React, { Component } from 'react'
import { BrowserRouter, Route } from 'react-router-dom';
import DataTable from '../../../components/DataTable/DataTable';
import FrontendBannerForm from './FrontendBannerForm';
import TitleHeader from '../../../components/TitleHeader/TitleHeader'

class FrontendBanner extends Component {
    render() {
        const columns = [
            { label: 'ชื่อ', align: 'left', name: 'name', search_type: 'string' },
            { label: 'ภาพ', align: 'center', name: 'img', sortable: false },
        ];

        const api_url = '/master/banner';

        return (
            <BrowserRouter>
                <div>
                    <TitleHeader program_name='แบนเนอร์' program_type='Frontend'></TitleHeader>
                    
                    <Route exact path={`${this.props.match.path}/`} component={() => (<DataTable columns={columns} allow_active={true} url={api_url}></DataTable>)} />
                    
                    <Route path={`${this.props.match.path}/create`} component={props => (<FrontendBannerForm {...props} url={api_url}></FrontendBannerForm>)} />
                    <Route path={`${this.props.match.path}/:id/edit`} component={props => (<FrontendBannerForm {...props} url={api_url}></FrontendBannerForm>)} />
                </div>
            </BrowserRouter>
        )
    }
}

export default FrontendBanner
